
/* injects from baggage-loader */

'use strict';

import AdminComponent from './admin.component';

// Import child states
import AdminHomePageModule from './home/admin.home.module';

const AdminPageModule = angular.module('admin-module', [
    'ui.router',

    // Inject child states
    AdminHomePageModule.name,

  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('admin', {
        url: '/admin',
        // Requires valid login to view
        protected: true,
        component: 'admin',
        // Resolve promises into controller bindings, see component for bindings
        resolve: { 
          role: function(User, $log) {
            // $log.log('Checking for admin access', User.roles, User.hasRole('Admins'))
            // Take user to page not found page if they don't have access
            return User.hasRoleAsync('Admins')
              .then(y => {
                // $log.log('Admin', y)
                if (!y) throw { redirect: 'page-not-found' }
              })
          }
        }
      });
  })
  .run(function ($transitions, $location, $rootScope, User) {


    $transitions.onSuccess({ to: 'admin.home' }, transition => {

      // Hide the header
      // $rootScope.appState.hideHeader = true;

      // Hide the footer
      $rootScope.appState.hideFooter = true;

    });

  })
  .component('admin', new AdminComponent());

export default AdminPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/admin/admin.module.js